module.exports = __webpack_public_path__ + "assets/cb6023be3af64601534ce8b88f36eda9.mp3";